import config from "@shared/config/client";
import { ICallableRequestBuilder } from "@/api/requestBuilder/types";
import { ArtOrderOffer } from "../types";
import queryString from "query-string";

const getOffersForArtOrder =
  (request: ICallableRequestBuilder<ArtOrderOffer[]>) =>
  async (id: string, pageOptions = { take: 10, skip: 0 }) => {
    const url = queryString.stringifyUrl({
      url: `${config.apiUrl}/art-order/offer/order/${id}`,
      query: { ...pageOptions },
    });

    return await request.call(url, (init) => ({
      ...init,
      method: "GET",
    }));
  };

const isArtistMadeOfferOnOrder =
  (request: ICallableRequestBuilder<boolean>) =>
  async (orderId: string, artistId: string) => {
    const url = queryString.stringifyUrl({
      url: `${config.apiUrl}/art-order/offer/artist/order/${orderId}`,
      query: {
        artistId,
      },
    });

    // This is hack becouse server returns boolean in typeof string
    const result = await request.call(url);
    return result.toString() === "true";
  };

const requests = {
  isArtistMadeOfferOnOrder,
  getOffersForArtOrder,
};

export default requests;
